import React from "react";
import {
  FaFacebookF,
  FaGoogle,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import { socialPlatformLabel } from "../constants/socialPlatforms";

const PLATFORM_CONFIG = {
  facebook: { Icon: FaFacebookF, color: "#1877F2" },
  instagram: { Icon: FaInstagram, color: "#E4405F" },
  twitter: { Icon: FaTwitter, color: "#1DA1F2" },
  linkedin: { Icon: FaLinkedinIn, color: "#0A66C2" },
  gmb: { Icon: FaGoogle, color: "#4285F4" },
  youtube: { Icon: FaYoutube, color: "#FF0000" },
  gmail: { Icon: SiGmail, color: "#EA4335" },
  google: { Icon: FaGoogle, color: "#4285F4" },
};

function normalizePlatform(platform) {
  return String(platform || "").trim().toLowerCase();
}

export function getSocialPlatformConfig(platform) {
  return PLATFORM_CONFIG[normalizePlatform(platform)] || null;
}

function SocialPlatformIcon({ platform, size = 18, className = "", showBackground = false }) {
  const config = getSocialPlatformConfig(platform);
  if (!config) return null;

  const { Icon, color } = config;
  const label = socialPlatformLabel(platform);

  if (showBackground) {
    return (
      <span
        className={`cportal-platform-icon cportal-platform-icon--badge ${className}`.trim()}
        style={{ backgroundColor: color }}
        title={label}
        aria-hidden="true"
      >
        <Icon size={size} color="#fff" />
      </span>
    );
  }

  return (
    <span
      className={`cportal-platform-icon ${className}`.trim()}
      style={{ color }}
      title={label}
      aria-hidden="true"
    >
      <Icon size={size} />
    </span>
  );
}

export function SocialPlatformWithLabel({ platform, className = "" }) {
  const label = socialPlatformLabel(platform);
  const hasIcon = Boolean(getSocialPlatformConfig(platform));

  return (
    <span className={`cportal-platform-with-icon ${className}`.trim()}>
      {hasIcon && <SocialPlatformIcon platform={platform} size={16} />}
      <span>{label || "—"}</span>
    </span>
  );
}

export default SocialPlatformIcon;
